import { useState } from "react";
import { OFFERS, OFFER_CATEGORIES } from "@/data/offers";
import { OfferCard } from "@/components/offers/OfferCard";
import { OfferDialog } from "@/components/offers/OfferDialog";
import { MarketIntelligence } from "@/components/offers/MarketIntelligence";
import "@/components/offers/offers.css";

export default function Offers() {
  const [category, setCategory] = useState("All offers");
  const [selected, setSelected] = useState(null);
  const offers = OFFERS.filter((offer) => category === "All offers" || offer.category === category);
  return (
    <div className="offers-page container-x" data-testid="offers-page">
      <header className="offers-heading">
        <p className="eyebrow" data-testid="offers-eyebrow">Partner benefits</p>
        <h1 className="t-h1" data-testid="offers-heading">Exclusive broker offers.</h1>
        <p className="t-lead" data-testid="offers-subtitle">Explore the latest promotions, cashback rewards and trading benefits from our partner brokers.</p>
      </header>
      <div className="offers-filter-bar">
        <div className="offers-filters" role="group" aria-label="Offer category">{OFFER_CATEGORIES.map((item) => <button key={item} onClick={() => setCategory(item)} aria-pressed={category === item} data-on={category === item} data-testid={`offers-filter-${item.toLowerCase().replace(/\s+/g, "-")}`}>{item}</button>)}</div>
        <span className="offers-count" role="status" aria-live="polite" data-testid="offers-count">{offers.length} {offers.length === 1 ? "offer" : "offers"}</span>
      </div>
      <div className="offers-grid" data-testid="offers-grid">{offers.map((offer) => <OfferCard key={offer.id} offer={offer} featured={offer.featured} onView={setSelected} />)}</div>
      <p className="offers-disclaimer" data-testid="offers-disclaimer">Illustrative promotions only. Availability, eligibility and terms are synthetic and subject to regional restrictions.</p>
      <MarketIntelligence />
      <OfferDialog offer={selected} onClose={() => setSelected(null)} />
    </div>
  );
}